module.exports = __webpack_public_path__ + "static/media/66084381f55f4238d69e5cbe3b8dc42e.66084381.svg";


//////////////////
// WEBPACK FOOTER
// ./src/app/res/images/discordAssets/66084381f55f4238d69e5cbe3b8dc42e.svg
// module id = 383
// module chunks = 17